import {
  Button,
  message,
  Modal,
  notification,
  Popover,
  Space,
  TableColumnType,
} from 'antd'
import React, { ReactElement, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dimen } from '../../models/dimen'
import moment from 'moment'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
} from '../../models/datetime'
import {
  Category,
  ctrlShowCol,
  getOutTitleName,
  getUnitTitleName,
} from '../../models/category'
import {
  AccountOutlined,
  DelectOutlined,
  ReverseOutlined,
} from '../../compnents/icons/Icons'
import { EditableColumnType } from '../../compnents/list/EditableList'
import { ItemCompletionType } from '../completion/completionSlice'
import {
  selectChainId,
  selectChainType,
  selectTenantId,
} from '../../app/applicationSlice'
import { useHistory } from 'react-router-dom'
import { ExclamationCircleFilled } from '@ant-design/icons'
import {
  getDeliveryFn,
  getQueryInboundFn,
  getReceiptConfirmFn,
  getReturnDeliveryFn,
  getReturnReceiptFn,
} from './chainSlice'
import { RootDispatch } from '../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'
import { traceRoute } from '../../layouts/layoutSlice'

export const getSelfExecuteTypeName = (selfExecuteType: string) => {
  switch (selfExecuteType) {
    case '0':
      return '未整改'
    case '1':
      return '已整改'
    case '9':
      return '已过期'
    default:
      return '-'
  }
}

export const getClassificationRuleName = (classificationRule: string) => {
  switch (classificationRule) {
    case '200':
      return '待提交'
    case '201':
      return '待审核'
    case '202':
      return '审核不通过'
    case '203':
      return '待出库'
    case '204':
      return '已出库'
    case '205':
      return '已入库'
    case '206':
      return '待提交'
    case '207':
      return '待审核'
    case '208':
      return '审核不通过'
    case '209':
      return '审核完成'
    case '210':
      return '已上传'
    case '211':
      return '已登账'
    default:
      return '-'
  }
}

export const getApproveStateName = (state: number) => {
  switch (state) {
    case 0:
      return '待提交'
    case 1:
      return '待审核'
    case 2:
      return '审核通过'
    case 3:
      return '审核不通过'
    default:
      return '-'
  }
}

export const Columns = (
  startIndex: number,
  onClick: (action: any, t: any) => void,
  category: Category
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '单据号',
      align: 'center',
      dataIndex: 'id',
      width: '8rem',
      ellipsis: true,
      key: 'id',
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '12rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '供应商',
      align: 'center',
      dataIndex: 'supplierName',
      width: '12rem',
      ellipsis: true,
      key: 'supplierName',
    },
    {
      title: '调拨方',
      align: 'center',
      dataIndex: 'source',
      width: '12rem',
      ellipsis: true,
      key: 'source',
    },
    // {
    //   title: '申领店铺',
    //   align: 'center',
    //   dataIndex: 'source',
    //   width: '12rem',
    //   ellipsis: true,
    //   key: 'source',
    // },
    {
      title: '申领品种',
      align: 'center',
      dataIndex: 'submittedCategoryCount',
      width: '8rem',
      ellipsis: true,
      key: 'submittedCategoryCount',
    },
    // {
    //   title: "申领总金额",
    //   align: "center",
    //   dataIndex: "submittedTotalAmount",
    //   width: "8rem",
    //   ellipsis: true,
    //   key: "submittedTotalAmount",
    // },
    {
      title: '实际调拨品种',
      align: 'center',
      dataIndex: 'actualCategoryCount',
      width: '8rem',
      ellipsis: true,
      key: 'actualCategoryCount',
    },
    {
      title: '实际调拨总金额',
      align: 'center',
      dataIndex: 'actualTotalAmount',
      width: '8rem',
      ellipsis: true,
      key: 'actualTotalAmount',
      render: (_, t) => {
        return t.actualTotalAmount > 0 ? t.actualTotalAmount?.toFixed(2) : ''
      },
    },
    {
      title: '接收库房',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
    },
    {
      title: '业务部门',
      align: 'center',
      dataIndex: 'departmentName',
      key: 'departmentName',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return tenantId == chainId ? t?.sourceDepartmentName : t?.departmentName
      },
    },
    {
      title: '业务人员',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'userName',
      key: 'userName',
      render: (_, t) => {
        return tenantId == chainId ? t?.sourceUserName : t?.userName
      },
    },
    {
      title: '审核员',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'approvedUserName',
      key: 'approvedUserName',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'createTime',
      // render: (_, t) => {
      //   return t.createTime ? moment(t.createTime).format(DateTimeFormatSimple) : '-'
      // }
    },
    {
      title: tenantId == chainId ? '出库时间' : '入库时间',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      //   sorter: (a: any, b: any) =>
      //     moment(a.upAccountTime).unix() - moment(b.upAccountTime).unix(),
      render: (_, t) => {
        return t.upAccountTime ? t.upAccountTime : ''
      },
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return getClassificationRuleName(t.storehouseTag)
      },
    },
    {
      width: '13rem',
      title: '操作',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: function Element(_, t) {
        return tenantId != chainId ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {t.storehouseTag == '200' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['连锁申领业务', '申领业务'],
                      name: '连锁申领业务',
                      backName: '连锁申领业务',
                      path: 'chainClaimBusiness',
                      category: Category.SLYW,
                      selectId: t.id,
                      detail: { ...t },
                    },
                  })
                }}
              >
                提交
              </Button>
            ) : (
              <></>
            )}
            {t.storehouseTag == '204' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  // onClick("入库", t);
                  Modal.confirm({
                    centered: true,
                    title: '确认操作',
                    content: (
                      <div>
                        <ExclamationCircleFilled
                          style={{ color: '#FFAE55', fontSize: 18 }}
                        />
                        &nbsp;是否确认入库？
                      </div>
                    ),
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      dispatch(getReceiptConfirmFn(t.id))
                        .then(unwrapResult)
                        .then(() => {
                          notification.success({
                            message: '操作成功',
                          })
                          onClick('list', t)
                        })
                    },
                  })
                }}
              >
                入库
              </Button>
            ) : (
              <></>
            )}
            {t.storehouseTag == '200' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  onClick('delete', t)
                }}
              >
                删除
              </Button>
            ) : (
              <></>
            )}
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={() => {
                history.push({
                  pathname: '/chainPutList',
                  state: {
                    where: [
                      tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                      tenantId == chainId ? '调拨出库' : '申领业务',
                    ],
                    name: tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                    backName:
                      tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                    path:
                      tenantId == chainId
                        ? '/chainTransferOutbound'
                        : 'chainClaimBusiness',
                    category:
                      tenantId == chainId ? Category.LSDBCK : Category.SLYW,
                    selectId: t.id,
                    detail: { ...t },
                  },
                })
              }}
            >
              查看详情
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {t.storehouseTag == '201' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['连锁申领业务', '申领业务'],
                      name: '连锁申领业务',
                      backName: '连锁申领业务',
                      path: '/chainClaimBusiness',
                      category: Category.SLYW,
                      selectId: t.id,
                      detail: { ...t },
                    },
                  })
                }}
              >
                去审核
              </Button>
            ) : (
              <></>
            )}
            {t.storehouseTag == '203' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  // onClick("出库", t);getgetDeliveryFn
                  Modal.confirm({
                    centered: true,
                    title: '确认操作',
                    content: (
                      <div>
                        <ExclamationCircleFilled
                          style={{ color: '#FFAE55', fontSize: 18 }}
                        />
                        &nbsp;是否确认出库？
                      </div>
                    ),
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      dispatch(getDeliveryFn(t.id))
                        .then(unwrapResult)
                        .then(() => {
                          notification.success({
                            message: '操作成功',
                          })
                          onClick('list', t)
                        })
                    },
                  })
                }}
              >
                出库
              </Button>
            ) : (
              <></>
            )}
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={() => {
                history.push({
                  pathname: '/chainPutList',
                  state: {
                    where: [
                      tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                      tenantId == chainId ? '调拨出库' : '申领业务',
                    ],
                    name: tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                    backName:
                      tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                    path:
                      tenantId == chainId
                        ? '/chainTransferOutbound'
                        : 'chainClaimBusiness',
                    category:
                      tenantId == chainId ? Category.LSDBCK : Category.SLYW,
                    selectId: t.id,
                    detail: { ...t },
                  },
                })
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
  return tenantId == chainId
    ? columns?.filter((v) => v.title != '接收库房')
    : columns?.filter((v) => v.title != '审核员')
}

export const ProcurementColumns = (
  startIndex: number,
  type: number,
  onClick: (action: any, t: any) => void,
  category: Category
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '单据号',
      align: 'center',
      dataIndex: 'id',
      width: '7rem',
      ellipsis: true,
      key: 'id',
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '11rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '库房名称',
      align: 'center',
      dataIndex: 'storehouseName',
      width: '11rem',
      ellipsis: true,
      key: 'storehouseName',
    },
    {
      title: '供应商',
      align: 'center',
      dataIndex: 'supplierName',
      width: '11rem',
      ellipsis: true,
      key: 'supplierName',
    },
    {
      title: '采购品种',
      align: 'center',
      dataIndex: 'submittedCategoryCount',
      width: '7rem',
      ellipsis: true,
      key: 'submittedCategoryCount',
    },
    {
      title: '采购金额',
      align: 'center',
      dataIndex: 'submittedTotalAmount',
      width: '7rem',
      ellipsis: true,
      key: 'submittedTotalAmount',
      render: (_, t) => {
        return t.submittedTotalAmount > 0 ? t.submittedTotalAmount : ''
      },
    },
    {
      title: '申请人',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '申请日期',
      dataIndex: 'createTime',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      key: 'createTime',
      //   sorter: (a: any, b: any) =>
      //     moment(a.createTime).unix() - moment(b.createTime).unix(),
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '审核人',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      dataIndex: 'approvedUserName',
      key: 'approvedUserName',
      render: (_, t) => {
        return t?.approvedUserName
      },
    },
    {
      title: '审核日期',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      render: (_, t) => {
        return t.approvedTime
          ? moment(t.approvedTime).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return getClassificationRuleName(t.storehouseTag)
      },
    },
    {
      title: '操作',
      fixed: 'right',
      width: '20rem',
      align: 'center',
      ellipsis:true,
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: function Element(_, t) {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {t.storehouseTag == 206 && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  if (type == 1) {
                    history.push({
                      pathname: '/chainPutList',
                      state: {
                        where: ['连锁业务', '采购业务'],
                        name: '连锁业务',
                        backName:
                          tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                        path: '/chainTransferOutbound',
                        category: Category.CGYW,
                        selectId: t.id,
                        detail: { ...t, type: 1 },
                      },
                    })
                  } else {
                    history.push({
                      pathname: '/chainPutList',
                      state: {
                        where: ['库房工作站', '采购业务'],
                        name: '单据列表',
                        backName: '库房工作站',
                        path: '/procorementBusiness',
                        category: Category.CGYW,
                        selectId: t.id,
                        detail: { ...t, type: 2 },
                        approvedUserName: t?.approvedUserName,
                      },
                    })
                  }
                }}
              >
                提交
              </Button>
            )}
            {t.storehouseTag == 206  && (
              <Button
                danger
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  onClick('delete', t)
                }}
              >
                删除
              </Button>
            )}
            {t.storehouseTag == 207 && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  if (type == 1) {
                    history.push({
                      pathname: '/chainPutList',
                      state: {
                        where: ['连锁业务', '采购业务'],
                        name: '连锁业务',
                        backName:
                          tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                        path: '/chainTransferOutbound',
                        category: Category.CGYW,
                        selectId: t.id,
                        detail: { ...t, type: 1 },
                      },
                    })
                  } else {
                    history.push({
                      pathname: '/chainPutList',
                      state: {
                        where: ['库房工作站', '采购业务'],
                        name: '单据列表',
                        backName: '库房工作站',
                        path: '/procorementBusiness',
                        category: Category.CGYW,
                        selectId: t.id,
                        detail: { ...t, type: 2 },
                        approvedUserName: t?.approvedUserName,
                      },
                    })
                  }
                }}
              >
                去审核
              </Button>
            )}
            {t.storehouseTag == 211 && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => onClick('search', t)}
              >
                入库查询
              </Button>
            )}
            {t.storehouseTag == 209 && chainType == 1 && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => onClick('upload', t)}
              >
                上传
              </Button>
            )}
            {t.storehouseTag == 210 && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => onClick('search', t)}
              >
                入库
              </Button>
            )}
            {t.storehouseTag == 209 &&
              chainType != 1  &&
              t.purchaseAcceptanceId < 0 && (
                <Button
                  type='text'
                  size='small'
                  style={{ color: '#027AFF', fontSize: '14px' }}
                  onClick={() => {
                    onClick('acceptance', t)
                  }}
                >
                  生成验收单
                </Button>
              )}
            {t.storehouseTag == 209 &&
               chainType != 1  &&
              t.stockInInventoryReceiptsId < 0 && (
                <Button
                  type='text'
                  size='small'
                  style={{ color: '#027AFF', fontSize: '14px' }}
                  onClick={() => {
                    onClick('storage', t)
                  }}
                >
                  生成入库单
                </Button>
              )}
            {(t.storehouseTag == 208 ||
              t.storehouseTag == 207 ||
              t.storehouseTag == 209) && (
              <Button
                danger
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  onClick('revocation', t)
                }}
              >
                撤回
              </Button>
            )}
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={() => {
                if (type == 1) {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['连锁业务', '采购业务'],
                      name: '连锁业务',
                      backName:
                        tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                      path: '/chainTransferOutbound',
                      category: Category.CGYW,
                      selectId: t.id,
                      detail: { ...t, type: 1 },
                    },
                  })
                } else {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['库房工作站', '采购业务'],
                      name: '单据列表',
                      backName: '库房工作站',
                      path: '/procorementBusiness',
                      category: Category.CGYW,
                      selectId: t.id,
                      detail: { ...t, type: 2 },
                      approvedUserName: t?.approvedUserName,
                    },
                  })
                }
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
  return columns
}

//采购退货
export const ReturnColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void,
  category: Category,
  activeKey?: any
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '单据号',
      align: 'center',
      dataIndex: 'id',
      width: '8rem',
      ellipsis: true,
      key: 'id',
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '12rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '供应商',
      align: 'center',
      dataIndex: 'supplierName',
      width: '12rem',
      ellipsis: true,
      key: 'supplierName',
    },
    {
      title: '退货品种',
      align: 'center',
      dataIndex: 'submittedCategoryCount',
      width: '8rem',
      ellipsis: true,
      key: 'submittedCategoryCount',
    },
    {
      title: '退货金额',
      align: 'center',
      dataIndex: 'submittedTotalAmount',
      width: '8rem',
      ellipsis: true,
      key: 'submittedTotalAmount',
      render: (_, t) => {
        return t.submittedTotalAmount > 0 ? t.submittedTotalAmount : ''
      },
    },
    {
      title: '申请人',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '申请日期',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'createTime',
      //   sorter: (a: any, b: any) =>
      //     moment(a.createTime).unix() - moment(b.createTime).unix(),
      render: (createTime) => {
        return createTime ? createTime : ''
      },
    },
    {
      title: '审核人',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'approvedUserName',
      key: 'approvedUserName',
      render: (_, t) => {
        return t?.approvedUserName
      },
    },
    {
      title: '审核日期',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.approvedTime ? t.approvedTime : ''
      },
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return getClassificationRuleName(t.storehouseTag)
      },
    },
    {
      width: '13rem',
      title: '操作',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: function Element(_, t) {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {t.storehouseTag == '206' && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['连锁业务', '退货业务'],
                      name: '连锁业务',
                      backName:
                        tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                      path: '/chainClaimBusiness',
                      activeKey: activeKey,
                      category: Category.CGTHYW,
                      selectId: t.id,
                      detail: { ...t },
                    },
                  })
                }}
              >
                提交
              </Button>
            )}
            {t.storehouseTag == '207' && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['连锁业务', '退货业务'],
                      name: '连锁业务',
                      backName:
                        tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                      path: '/chainClaimBusiness',
                      activeKey: activeKey,
                      category: Category.CGTHYW,
                      selectId: t.id,
                      detail: { ...t },
                    },
                  })
                }}
              >
                去审核
              </Button>
            )}
            {t.storehouseTag == '210' && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => onClick('submit', t)}
              >
                退货确认
              </Button>
            )}
            {t.storehouseTag == '209' && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => onClick('upload', t)}
              >
                上传
              </Button>
            )}
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={() => {
                history.push({
                  pathname: '/chainPutList',
                  state: {
                    where: ['连锁业务', '退货业务'],
                    name: '连锁业务',
                    backName:
                      tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                    path: '/chainClaimBusiness',
                    activeKey: activeKey,
                    category: Category.CGTHYW,
                    selectId: t.id,
                    detail: { ...t },
                  },
                })
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
  return columns
}

//分店退货
export const ReturnColumnsBranch = (
  startIndex: number,
  onClick: (action: any, t: any) => void,
  category: Category
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '单据号',
      align: 'center',
      dataIndex: 'id',
      width: '8rem',
      ellipsis: true,
      key: 'id',
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '12rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '收货门店',
      align: 'center',
      dataIndex: 'source',
      width: '8rem',
      ellipsis: true,
      key: 'source',
    },
    {
      title: '退货品种',
      align: 'center',
      dataIndex: 'submittedCategoryCount',
      width: '8rem',
      ellipsis: true,
      key: 'submittedCategoryCount',
    },
    {
      title: '退货总金额',
      align: 'center',
      dataIndex: 'actualTotalAmount',
      width: '8rem',
      ellipsis: true,
      key: 'actualTotalAmount',
      render: (_, t) => {
        return t.actualTotalAmount > 0 ? t.actualTotalAmount : ''
      },
    },
    {
      title: '退货药房',
      align: 'center',
      dataIndex: 'storehouseName',
      width: '8rem',
      ellipsis: true,
      key: 'storehouseName',
    },
    {
      title: '业务部门',
      align: 'center',
      dataIndex: 'departmentName',
      width: '8rem',
      ellipsis: true,
      key: 'departmentName',
    },
    {
      title: '业务人员',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'userName',
      key: 'userName',
      render: (_, t) => {
        return t?.userName
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'createTime',
      // render: (_, t) => {
      //   return t.createTime ? moment(t.createTime).format(DateTimeFormatSimple) : '-'
      // }
    },
    {
      title: '出库时间',
      align: 'center',
      width: '10rem',
      dataIndex: 'upAccountTime',
      ellipsis: true,
      // render: (_, t) => {
      //   return t.upAccountTime ? moment(t.upAccountTime).format(DateTimeFormatSimple) : '-'
      // }
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return getClassificationRuleName(t.storehouseTag)
      },
    },
    {
      width: '13rem',
      title: '操作',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: function Element(_, t) {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {t.storehouseTag == '200' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['连锁业务', '退货业务'],
                      name: '连锁业务',
                      backName: '连锁申领业务',
                      path: '/chainClaimBusiness',
                      category: Category.FDTHYW,
                      selectId: t.id,
                      detail: { ...t },
                    },
                  })
                }}
              >
                提交
              </Button>
            ) : (
              <></>
            )}
            {t.storehouseTag == '203' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  Modal.confirm({
                    centered: true,
                    title: '确认操作',
                    content: (
                      <div>
                        <ExclamationCircleFilled
                          style={{ color: '#FFAE55', fontSize: 18 }}
                        />
                        &nbsp;是否确认出库？
                      </div>
                    ),
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      dispatch(getReturnReceiptFn(t.id))
                        .then(unwrapResult)
                        .then(() => {
                          notification.success({
                            message: '操作成功',
                          })
                          onClick('list', t)
                        })
                    },
                  })
                }}
              >
                出库确认
              </Button>
            ) : (
              <></>
            )}
            {t.storehouseTag == '200' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  onClick('delete', t)
                }}
              >
                删除
              </Button>
            ) : (
              <></>
            )}
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={() => {
                history.push({
                  pathname: '/chainPutList',
                  state: {
                    where: ['连锁业务', '退货业务'],
                    name: '连锁业务',
                    backName: '连锁申领业务',
                    path: '/chainClaimBusiness',
                    category: Category.FDTHYW,
                    selectId: t.id,
                    action: true,
                    detail: { ...t },
                  },
                })
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
  return columns
}

//总店退货
export const ReturnColumnsHead = (
  startIndex: number,
  onClick: (action: any, t: any) => void,
  category: Category
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '单据号',
      align: 'center',
      dataIndex: 'id',
      width: '8rem',
      ellipsis: true,
      key: 'id',
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '12rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '退货门店',
      align: 'center',
      dataIndex: 'source',
      width: '10rem',
      ellipsis: true,
      key: 'source',
    },
    {
      title: '退货品种',
      align: 'center',
      dataIndex: 'submittedCategoryCount',
      width: '8rem',
      ellipsis: true,
      key: 'submittedCategoryCount',
    },
    {
      title: '退货总金额',
      align: 'center',
      dataIndex: 'submittedTotalAmount',
      width: '8rem',
      ellipsis: true,
      key: 'submittedTotalAmount',
      render: (_, t) => {
        return t.submittedTotalAmount > 0 ? t.submittedTotalAmount : ''
      },
    },
    {
      title: '业务部门',
      align: 'center',
      dataIndex: 'sourceDepartmentName',
      width: '8rem',
      ellipsis: true,
      key: 'sourceDepartmentName',
    },
    {
      title: '业务人员',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'sourceUserName',
      key: 'sourceUserName',
    },
    {
      title: '审核人',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'approvedUserName',
      key: 'approvedUserName',
      render: (_, t) => {
        return t?.approvedUserName
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'createTime',
      // render: (_, t) => {
      //   return t.createTime ? moment(t.createTime).format(DateTimeFormatSimple) : '-'
      // }
    },
    {
      title: '入库时间',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'upAccountTime',
      // render: (_, t) => {
      //   return t.createTime ? moment(t.createTime).format(DateTimeFormatSimple) : '-'
      // }
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return getClassificationRuleName(t.storehouseTag)
      },
    },
    {
      width: '13rem',
      title: '操作',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: function Element(_, t) {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {t.storehouseTag == '201' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['连锁业务', '门店退货业务'],
                      name: '连锁业务',
                      backName: '连锁申领业务',
                      path: '/chainClaimBusiness',
                      category: Category.ZDTHYW,
                      selectId: t.id,
                      detail: { ...t },
                    },
                  })
                }}
              >
                去审核
              </Button>
            ) : (
              <></>
            )}
            {t.storehouseTag == '204' ? (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  onClick('putInto', t)
                }}
              >
                入库确认
              </Button>
            ) : (
              <></>
            )}
            {t.storehouseTag == '205' && (
              <Button
                type='text'
                size='small'
                style={{ color: '#027AFF', fontSize: '14px' }}
                onClick={() => onClick('search', t)}
              >
                入库查询
              </Button>
            )}
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={() => {
                history.push({
                  pathname: '/chainPutList',
                  state: {
                    where: ['连锁出库', '门店退货业务'],
                    name: '连锁业务',
                    backName: '连锁调拨出库',
                    path: '/chainTransferOutbound',
                    category: Category.ZDTHYW,
                    selectId: t.id,
                    action: true,
                    detail: { ...t },
                  },
                })
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
  return columns
}

// 200
export const DetailSLColumns = (
  storehouseId: string,
  storehouseTag: number,
  onclick: (text: string, t: any) => void,
  normalGysName?: any
): EditableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  return [
    {
      title: '操作',
      align: 'center',
      width: '64px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={
                storehouseTag == 200 && tenantId != chainId ? false : true
              }
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={
                storehouseTag == 200 && tenantId != chainId ? false : true
              }
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '药品名称',
      align: 'center',
      dataIndex: 'name',
      width: '210px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'count',
      storehouseId: storehouseId,
      normalGysName: normalGysName,
      editable: storehouseTag == 200 && tenantId != chainId ? true : false,
      inputType: 'material',
      completionType: ItemCompletionType.Material,
      onSelectMaterial: (prev, newdata) => {
        const tenantMaterialsCatalogId = newdata.id
        const unitPrice = newdata.stockPrice > 0 ? newdata.stockPrice : 0
        const next = {
          ...newdata,
          unitPrice,
          tenantMaterialsCatalogId,
          id: undefined,
        }
        onclick('edit', { prev, next })
      },
    },
    // {
    //   title: "通用名",
    //   align: "center",
    //   dataIndex: "genericName",
    //   width: "11rem",
    //   ellipsis: true,
    //   key: "nogenericName",
    //   render: (_: any, t: any) => {
    //     return Number(t.genericName) !== 0 ? t.genericName : "";
    //   },
    // },
    // ...(tenantId != chainId
    //   ? [
    //       {
    //         title: "通用名",
    //         align: "center",
    //         dataIndex: "genericName",
    //         width: "11rem",
    //         ellipsis: true,
    //         key: "nogenericName",
    //         render: (_: any, t: any) => {
    //           return Number(t.genericName) !== 0 ? t.genericName : "";
    //         },
    //       },
    //     ]
    //   : []),
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '470px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return <>{t.productInfo}</>
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                {t.tenantSupplierName}
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    // {
    //   title: "进价",
    //   dataIndex: "unitPrice",
    //   width: "100px",
    //   ellipsis: true,
    //   align: "center",
    //   editable: storehouseTag == 200 && tenantId != chainId ? true : false,
    //   nextDataIndex: "submittedCategoryCount",
    //   rules: [
    //     {
    //       required: true,
    //       message: "请输入进价",
    //     },
    //     {
    //       pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
    //       message: "请输入正确的格式，最多保留小数点后5位",
    //     },
    //   ],
    //   onSave: (prev, next) => {
    //     onclick(prev.id ? "submit" : "edit", { prev, next });
    //   },
    //   render: (_, t) => {
    //     return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : "";
    //   },
    // },
    {
      title: '申领数量',
      dataIndex: 'count',
      width: '100px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag == 200 && tenantId != chainId ? true : false,
      rules: [
        {
          required: true,
          message: '请输入数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        onclick('submit', { prev, next })
      },
      render: (_, t) => {
        return tenantId == chainId
          ? t?.needCount
          : storehouseTag > 201
          ? t?.needCount
          : t?.count
      },
    },
    // {
    //   title: "申领金额",
    //   dataIndex: "totalPrice",
    //   width: "100px",
    //   ellipsis: true,
    //   align: "center",
    // },
    // ...(tenantId == chainId ||
    // (tenantId != chainId && storehouseTag == 203) ||
    // (tenantId != chainId && storehouseTag == 204) ||
    // (tenantId != chainId && storehouseTag == 205)
    //   ? [
    //       {
    //         title: "实际调拨数量",
    //         dataIndex: "stockCount",
    //         width: "130px",
    //         ellipsis: true,
    //         align: "center",
    //         render: function Element(_: any, t: any) {
    //           return (
    //             <span
    //               style={{
    //                 color: t.stockCount < t.needCount ? "#FF1B1B" : "#101010",
    //               }}
    //             >
    //               {t.stockCount}
    //             </span>
    //           );
    //         },
    //       },
    //     ]
    //   : []),
    {
      title: '实际调拨数量',
      dataIndex: 'stockCount',
      width: '130px',
      ellipsis: true,
      align: 'center',
      render: function Element(_: any, t: any) {
        return (
          <span
            style={{
              color: t.stockCount < t.needCount ? '#FF1B1B' : '#101010',
            }}
          >
            {t.stockCount || '-'}
          </span>
        )
      },
    },
    // ...(tenantId == chainId
    //   ? [
    //       {
    //         title: "实际调拨金额",
    //         dataIndex: "stockPrice",
    //         align: "center",
    //         width: "130px",
    //         ellipsis: true,
    //       },
    //     ]
    //   : []),
    {
      title: '实际调拨金额',
      dataIndex: 'stockPrice',
      align: 'center',
      width: '130px',
      ellipsis: true,
      render: (_, t) => {
        return t.stockPrice && storehouseTag > 200
          ? t.stockPrice?.toFixed(2)
          : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '100px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <Space>
            {tenantId != chainId ? (
              storehouseTag == 200 && (
                <Button
                  type={t.id ? 'ghost' : 'primary'}
                  // disabled={storehouseTag > 0 ? true : false}
                  onClick={() => {
                    onclick('save', t)
                  }}
                >
                  保存
                </Button>
              )
            ) : (
              <></>
            )}
            {(storehouseTag == 203 ||
              storehouseTag == 204 ||
              storehouseTag == 205) && (
              <Button
                type='primary'
                onClick={() => {
                  onclick('detail', t)
                }}
              >
                批次查看
              </Button>
            )}
            {(tenantId == chainId && storehouseTag == 201) ||
            (tenantId == chainId && storehouseTag) == 202 ? (
              <Button
                type='primary'
                onClick={() => {
                  onclick('select', t)
                }}
                disabled={!t?.batchs?.length || storehouseTag == 202}
              >
                批次选择
              </Button>
            ) : (
              <></>
            )}
          </Space>
        )
      },
    },
  ]
}

//采购业务
export const DetailCGColumns = (
  storehouseId: string,
  storehouseTag: string,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const [nexIndexCount, setNexIndexCount] = useState<any>()

  return [
    {
      title: '操作',
      align: 'center',
      width: '64px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag == '206' ? false : true}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag == '206' ? false : true}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '商品ID',
      dataIndex: 'id',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.id ? t?.id : '-' 
      },
    },
    // 0512通用名修改 药品名称->通用名
    {
      title: '通用名',
      align: 'center',
      dataIndex: 'name',
      width: '12rem',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'count',
      storehouseId: storehouseId,
      editable: storehouseTag == '206' ? true : false,
      inputType: 'material',
      completionType: ItemCompletionType.Material,
      onSelectMaterial: (prev, newdata) => {
        const tenantMaterialsCatalogId = newdata.id
        const next = {
          ...newdata,
          tenantMaterialsCatalogId,
          count: '',
          id: undefined,
          stockPrice: newdata?.stockPrice != -1 && newdata?.stockPrice,
          unitPrice: newdata?.unitPrice != -1 && newdata?.unitPrice,
          splitTag: 0,
        }
        onclick('edit', { prev, next })
        setNexIndexCount(null as any)
        setNexIndexCount('count')
      },
    },
    // 0512通用名修改 通用名->商品名
    {
      title: '商品名',
      align: 'center',
      dataIndex: 'genericName',
      width: '12rem',
      ellipsis: true,
      key: 'nogenericName',
      render: (_: any, t: any) => {
        return Number(t.genericName) !== 0 ? t.genericName : ''
      },
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '24rem',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return <>{t.productInfo}</>
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                {t.tenantSupplierName}
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    {
      title: '采购单价',
      dataIndex: 'unitPrice',
      width: '7rem',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag == '206' ? true : false,
      // nextDataIndex: nexIndexCount,
      rules: [
        {
          required: true,
          message: '请输入进价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
        // setNexIndexCount(null as any)
        // setNexIndexCount(prev?.id ? (null as any) : 'count')
      },
      render: function Element(_, t) {
        return (
          <span
            onClick={(v) => {
              setNexIndexCount(null as any)
              setNexIndexCount(t?.id ? (null as any) : 'count')
            }}
          >
            {t.stockPrice
              ? parseFloat(t.stockPrice).toFixed(5)
              : t.unitPrice
              ? parseFloat(t.unitPrice).toFixed(5)
              : ''}
          </span>
        )
      },
    },
    {
      title: '采购数量',
      dataIndex: 'count',
      width: '7rem',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag == '206' ? true : false,
      rules: [
        {
          required: true,
          message: '请输入数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        onclick('submit', { prev, next })
      },
      render: (_, t) => {
        return t?.count
      },
    },
    {
      title: '真实采购数量',
      dataIndex: 'realCount',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return (t.realCount && t.realCount != 0 && t.realCount != -1) ? t.realCount : '-'
      },
    },
    {
      title: '采购金额',
      dataIndex: 'totalPrice',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      render: (_, t) => {
        return t.totalPrice ? Number(t.totalPrice)?.toFixed(2) : '-'
      },
    },
        {
      title: '真实采购金额',
      dataIndex: 'realPurchaseAmount',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.realCount && t.realCount != -1 && t.unitPrice 
          ? (t.realCount * t.unitPrice).toFixed(2) 
          : '-';
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t?.tenantMaterialsCatalogId && (
            <Space>
              <Button
                ghost
                type={'primary'}
                disabled={storehouseTag > '206' ? true : false}
                onClick={() => {
                  onclick('save', t)
                }}
              >
                保存
              </Button>
            </Space>
          )
        )
      },
    },
  ]
}

//采购业务退货
export const DetailCGTHColumns = (
  storehouseId: string,
  storehouseTag: string,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  return [
    {
      title: '操作',
      align: 'center',
      width: '64px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag == '206' ? false : true}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag == '206' ? false : true}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    // 0512通用名修改 药品名称->通用名
    {
      title: '通用名',
      align: 'center',
      dataIndex: 'name',
      width: '210px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'count',
      storehouseId: storehouseId,
      editable: storehouseTag == '206' ? true : false,
      inputType: 'material',
      completionType: ItemCompletionType.AllInventory,
      onSelectMaterial: (prev, newdata) => {
        const tenantInventoryLedgerId = newdata.id
        // const unitPrice = newdata.stockPrice > 0 ? newdata.stockPrice : 0;
        const next = {
          ...newdata,
          // unitPrice,
          tenantInventoryLedgerId,
          id: undefined,
        }
        onclick('edit', { prev, next })
      },
    },
    // 0512通用名修改 通用名->商品名
    {
      title: '商品名',
      align: 'center',
      dataIndex: 'genericName',
      width: '11rem',
      ellipsis: true,
      key: 'nogenericName',
      render: (_: any, t: any) => {
        return Number(t.genericName) !== 0 ? t.genericName : ''
      },
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '470px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return <>{t.productInfo}</>
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                {t.tenantSupplierName}
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '130px',
      ellipsis: true,
      render: (_, t) => {
        return t.batchNo ? t.batchNo : '-'
      },
    },
    {
      title: '有效期',
      dataIndex: 'deadline',
      align: 'center',
      width: '130px',
      ellipsis: true,
      render: (_, t) => {
        return t.deadline &&
          t.deadline !== undefined &&
          t.deadline !== '' &&
          t.deadline !== 'Invalid date'
          ? moment(t.deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '进价',
      dataIndex: 'unitPrice',
      width: '100px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag == '206' ? true : false,
      nextDataIndex: 'count',
      rules: [
        {
          required: true,
          message: '请输入进价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: (_, t) => {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '实际数量',
      dataIndex: 'invCount',
      width: '100px',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        return t?.invCount || t?.count
      },
    },
    {
      title: '退货数量',
      dataIndex: 'count',
      width: '100px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag == '206' ? true : false,
      rules: [
        {
          required: true,
          message: '请输入数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        const num = prev?.invCount || prev?.count
        if(num < next.count) {
          return message.error('退货数量不能大于实际数量')
        }
        onclick('submit', { prev, next })
      },
      render: (_, t) => {
        return t?.count
      },
    },
    {
      title: '采购金额',
      dataIndex: 'totalPrice',
      align: 'center',
      width: '130px',
      ellipsis: true,
      render: (_, t) => {
        return t.totalPrice ? t.totalPrice : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '100px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <Space>
            <Button
              type={t.id ? 'ghost' : 'primary'}
              disabled={storehouseTag > '206' ? true : false}
              onClick={() => {
                onclick('save', t)
              }}
            >
              保存
            </Button>
          </Space>
        )
      },
    },
  ]
}

//分店，总店退货
export const DetailLSTHColumns = (
  storehouseId: string,
  storehouseTag: string,
  action: boolean,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const columns: EditableColumnType<any>[] = [
    {
      title: '操作',
      align: 'center',
      width: '64px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag == '200' ? false : true}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag == '200' ? false : true}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    // 0512通用名修改 药品名称->通用名
    {
      title: '通用名',
      align: 'center',
      dataIndex: 'name',
      width: '210px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'count',
      storehouseId: storehouseId,
      editable: storehouseTag == '200' ? true : false,
      inputType: 'material',
      completionType: ItemCompletionType.AllInventory,
      onSelectMaterial: (prev, newdata) => {
        const tenantInventoryLedgerId = newdata.id
        // const unitPrice = newdata.stockPrice > 0 ? newdata.stockPrice : 0;
        const next = {
          ...newdata,
          // unitPrice,
          totalPrice: '',
          tenantInventoryLedgerId,
          id: undefined,
        }
        onclick('edit', { prev, next })
      },
    },
    // 0512通用名修改 通用名->商品名
    {
      title: '商品名',
      align: 'center',
      dataIndex: 'genericName',
      width: '11rem',
      ellipsis: true,
      key: 'nogenericName',
      render: (_: any, t: any) => {
        return Number(t.genericName) !== 0 ? t.genericName : ''
      },
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '470px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return <>{t.productInfo}</>
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                {t.tenantSupplierName}
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '130px',
      ellipsis: true,
      render: (_, t) => {
        return t.batchNo ? t.batchNo : '-'
      },
    },
    {
      title: '有效期',
      dataIndex: 'deadline',
      align: 'center',
      width: '130px',
      ellipsis: true,
      render: (_, t) => {
        return t.deadline &&
          t.deadline !== undefined &&
          t.deadline !== '' &&
          t.deadline !== 'Invalid date'
          ? moment(t.deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '进价',
      dataIndex: 'unitPrice',
      width: '100px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag == '200' ? true : false,
      nextDataIndex: 'count',
      rules: [
        {
          required: true,
          message: '请输入进价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: (_, t) => {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '实际数量',
      dataIndex: 'invCount',
      width: '100px',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        return t?.invCount || t?.count
      },
    },
    {
      title: '退货数量',
      dataIndex: 'count',
      width: '100px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag == '200' ? true : false,
      rules: [
        {
          required: true,
          message: '请输入数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        onclick('submit', { prev, next })
      },
      render: (_, t) => {
        return t?.count
      },
    },
    {
      title: '退货金额',
      dataIndex: 'totalPrice',
      align: 'center',
      width: '130px',
      ellipsis: true,
      // render: (_, t) => {
      //   return t.totalPrice ? t.totalPrice : "-";
      // },
    },
    {
      title: '操作',
      align: 'center',
      width: '100px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <Space>
            <Button
              type={t.id ? 'ghost' : 'primary'}
              disabled={storehouseTag > '200' ? true : false}
              onClick={() => {
                onclick('save', t)
              }}
            >
              保存
            </Button>
          </Space>
        )
      },
    },
  ]

  return tenantId == chainId
    ? action || Number(storehouseTag) > 200
      ? columns?.filter((v) => v.title != '实际数量' && v.title != '操作')
      : columns?.filter((v) => v.title != '实际数量')
    : action || Number(storehouseTag) > 200
    ? columns?.filter((v) => v.title != '操作')
    : columns
}

export const PiCiColumns = (
  actionType: string,
  storehouseTag: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const columns: EditableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: '批次',
      align: 'center',
      dataIndex: 'subInventoryLedgerBatchNo',
      width: '4rem',
      ellipsis: true,
    },
    {
      title: '库存数量',
      align: 'center',
      dataIndex: 'availableCount',
      width: '6rem',
      ellipsis: true,
    },
    {
      title: '所属库房',
      align: 'center',
      dataIndex: 'subStorehouseName',
      width: '6rem',
      ellipsis: true,
    },
    {
      title: '生产日期',
      align: 'center',
      dataIndex: 'productDate',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.productDate
          ? moment(t.productDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.deadline
          ? moment(t.deadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '进价',
      align: 'center',
      dataIndex: 'costPrice',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '调拨数量',
      align: 'center',
      dataIndex: 'count',
      width: '8rem',
      ellipsis: true,
      editable: actionType == 'select' ? true : false,
      rules: [
        {
          required: true,
          message: '请输入数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        onclick('submit', { prev, next })
      },
    },
  ]

  return tenantId == chainId && storehouseTag == 201
    ? columns
    : columns.filter((item) => item.dataIndex !== 'availableCount')
}

//入库查询
export const SearchColumns = (category: string): EditableColumnType<any>[] => {
  const columns: EditableColumnType<any>[] = [
    {
      title: '药品名称',
      align: 'center',
      dataIndex: 'name',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '批次号',
      align: 'center',
      dataIndex: 'batchNo',
      width: '6rem',
      ellipsis: true,
    },
    {
      title: '生产日期',
      align: 'center',
      dataIndex: 'productDate',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.productDate
          ? moment(t.productDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.deadline
          ? moment(t.deadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '收货数量',
      align: 'center',
      dataIndex: 'count',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '隔离数量',
      align: 'center',
      dataIndex: 'isolationCount',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '待验数量',
      align: 'center',
      dataIndex: 'pendingVerificationCount',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '收货日期',
      align: 'center',
      dataIndex: 'upAccountTime',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.upAccountTime
          ? moment(t.upAccountTime).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '收货人',
      align: 'center',
      dataIndex: 'upAccountUserName',
      width: '8rem',
      ellipsis: true,
    },
  ]

  return category == Category.CGYW
    ? columns.filter((item) => item.dataIndex !== 'upAccountUserName')
    : columns
}

// 复制调拨单
export const CopyColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '10rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '调拨方',
      align: 'center',
      dataIndex: 'source',
      width: '10rem',
      ellipsis: true,
      key: 'source',
    },
    // {
    //   title: '申领店铺',
    //   align: 'center',
    //   dataIndex: 'source',
    //   width: '8rem',
    //   ellipsis: true,
    //   key: 'source',
    // },
    {
      title: '申领品种',
      align: 'center',
      dataIndex: 'submittedCategoryCount',
      width: '6rem',
      ellipsis: true,
      key: 'submittedCategoryCount',
    },
    {
      title: '业务部门',
      align: 'center',
      dataIndex: 'departmentName',
      key: 'departmentName',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return tenantId == chainId ? t?.sourceDepartmentName : t?.departmentName
      },
    },
    {
      title: '业务人员',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'userName',
      key: 'userName',
      render: (_, t) => {
        return tenantId == chainId ? t?.sourceUserName : t?.userName
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'createTime',
      // render: (_, t) => {
      //   return t.createTime ? moment(t.createTime).format(DateTimeFormatSimple) : '-'
      // }
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return getClassificationRuleName(t.storehouseTag)
      },
    },
    {
      title: '操作',
      width: '5rem',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: function Element(_, t) {
        return (
          <>
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={() => {
                onClick('detail', t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}

//验收单
export const CopyDetailColumns = (
  startIndex: number,
  storehouseTag: number
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // 0512通用名修改 药品名称->通用名
    {
      title: '通用名',
      align: 'center',
      dataIndex: 'name',
      width: '12rem',
      ellipsis: true,
      key: 'name',
    },
    // 0512通用名修改 通用名->商品名
    {
      title: '商品名',
      align: 'center',
      dataIndex: 'genericName',
      width: '12rem',
      ellipsis: true,
      key: 'nogenericName',
      render: (_: any, t: any) => {
        return Number(t.genericName) !== 0 ? t.genericName : ''
      },
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return <>{t.productInfo}</>
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                {t.tenantSupplierName}
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    {
      title: '进价',
      dataIndex: 'unitPrice',
      width: '8rem',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '申领数量',
      dataIndex: 'branchCount',
      width: '8rem',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        return t?.branchCount
      },
    },
    {
      title: '申领金额',
      dataIndex: 'branchAmount',
      width: '8rem',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        return t.branchAmount ? parseFloat(t.branchAmount).toFixed(2) : ''
      },
    },
  ]
  return columns
}

export const CopyDetailYSYWColumns = (
  startIndex: number
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return (
            <Popover
              content={
                <div>
                  <div style={{ lineHeight: '1.8em', fontWeight: 'bold' }}>
                    {t.name}
                  </div>
                  <div style={{ lineHeight: '1.8em', color: '#999999' }}>
                    {t.productInfo}
                  </div>
                </div>
              }
            >
              <div
                style={{
                  textAlign: 'left',
                  lineHeight: '1.2em',
                  fontWeight: 'bold',
                }}
              >
                {t.name}
              </div>
              <div
                style={{
                  lineHeight: '1.2em',
                  color: '#999999',
                  textAlign: 'left',
                }}
              >
                {t.productInfo}
              </div>
            </Popover>
          )
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                <div style={{ textAlign: 'left' }}>{t.name}</div>
                {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                {t.tenantSupplierName}
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    {
      title: '采购单价',
      dataIndex: 'unitPrice',
      width: '8rem',
      ellipsis: true,
      align: 'center',
      render: function Element(_, t) {
        return (
          <span>
            {t.stockPrice
              ? parseFloat(t.stockPrice).toFixed(5)
              : t.unitPrice
              ? parseFloat(t.unitPrice).toFixed(5)
              : ''}
          </span>
        )
      },
    },
    {
      title: '采购数量',
      dataIndex: 'branchCount',
      width: '8rem',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        return t?.branchCount
      },
    },
    {
      title: '采购金额',
      dataIndex: 'branchAmount',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.branchAmount ? t.branchAmount : '-'
      },
    },
  ]
  return columns
}

//验收单
export const AcceptanceColumns = (
  startIndex: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const [nexIndexCount, setNexIndexCount] = useState<any>()
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '200px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return (
            <Popover
              content={
                <div>
                  <div style={{ lineHeight: '1.8em', fontWeight: 'bold' }}>
                    {t.name}
                  </div>
                  <div style={{ lineHeight: '1.8em', color: '#999999' }}>
                    {t.productInfo}
                  </div>
                </div>
              }
            >
              <div
                style={{
                  textAlign: 'left',
                  lineHeight: '1.2em',
                  fontWeight: 'bold',
                }}
              >
                {t.name}
              </div>
              <div style={{ lineHeight: '1.2em', color: '#999999' }}>
                {t.productInfo}
              </div>
            </Popover>
          )
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                <div style={{ textAlign: 'left' }}>{t.name}</div>
                {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                {t.tenantSupplierName}
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '60px',
      ellipsis: true,
      nextDataIndex: 'arrivalUnitPrice',
      editable: true,
      rules: [
        {
          required: true,
          message: '请输入批号',
        },
        {
          pattern: new RegExp(/^\S.*\S$/),
          message: '请按规范输入',
        },
      ],
      onSave: (prev, next) => {
        // setNexIndexCount(null as any)
        setNexIndexCount('arrivalUnitPrice')
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_, t: any) {
        return (
          <span
            onClick={() => {
              // setNexIndexCount(null as any)
              setNexIndexCount('arrivalUnitPrice')
            }}
          >
            {t.batchNo}
          </span>
        )
      },
    },
    {
      title: '购进价格',
      dataIndex: 'arrivalUnitPrice',
      width: '100px',
      ellipsis: true,
      align: 'center',
      editable: true,
      nextDataIndex: 'productDate',
      rules: [
        {
          required: true,
          message: '请输入进价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.arrivalUnitPrice && t.arrivalUnitPrice >= 0
          ? parseFloat(t.arrivalUnitPrice)?.toFixed(5)
          : ''
      },
    },
    {
      title: '生产日期',
      align: 'center',
      dataIndex: 'productDate',
      width: '100px',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'deadline',
      rules: [
        { required: true, message: '请输入生产日期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', {
          ...prev,
          productDate: moment(next.productDate).format(DateTimeFormat),
        })
      },
      render: (productDate) => {
        return productDate &&
          productDate !== undefined &&
          productDate !== '' &&
          productDate !== 'Invalid date'
          ? moment(productDate).format(DateTimeFormatSimple)
          : undefined
      },
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '100px',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'totalQuantity',
      onSave: (prev, next) => {
        onclick('edit', {
          ...prev,
          deadline: moment(next.deadline).format(DateTimeFormat),
        })
      },
      rules: [
        { required: true, message: '请输入有效期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (deadline) => {
        return deadline &&
          deadline !== undefined &&
          deadline !== '' &&
          deadline !== 'Invalid date'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '到货数量',
      dataIndex: 'totalQuantity',
      width: '100px',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'qualifiedQuantity',
      align: 'center',
      rules: [
        {
          required: true,
          message: '请输入到货数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.totalQuantity) > Number(prev.count)) {
          notification.error({
            message: '到货数量不能大于采购数量',
          })
          return
        }
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.totalQuantity >= 0 ? t.totalQuantity : ''
      },
    },
    {
      title: '验收合格数量',
      dataIndex: 'qualifiedQuantity',
      width: '120px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'defectiveQuantity',
      rules: [
        {
          required: true,
          message: '请输入验收合格数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.qualifiedQuantity) > Number(prev.totalQuantity)) {
          notification.error({
            message: '验收合格数量不能大于到货数量',
          })
          return
        }
        if (
          Number(next.qualifiedQuantity) + Number(prev.defectiveQuantity) >
          Number(prev.totalQuantity)
        ) {
          notification.error({
            message: '验收合格数量和验收不合格数量之和不能大于到货数量',
          })
          return
        }
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.qualifiedQuantity >= 0 ? t.qualifiedQuantity : ''
      },
    },
    {
      title: '验收不合格数量',
      dataIndex: 'defectiveQuantity',
      width: '130px',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'qualityStatus',
      align: 'center',
      rules: [
        {
          required: true,
          message: '请输入验收不合格数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.defectiveQuantity) > Number(prev.totalQuantity)) {
          notification.error({
            message: '验收合格数量不能大于到货数量',
          })
          return
        }
        if (
          Number(prev.qualifiedQuantity) + Number(next.defectiveQuantity) >
          Number(prev.totalQuantity)
        ) {
          notification.error({
            message: '验收合格数量和验收不合格数量之和不能大于到货数量',
          })
          return
        }
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.defectiveQuantity >= 0 ? t.defectiveQuantity : ''
      },
    },
    {
      title: '质量状况',
      dataIndex: 'qualityStatus',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'acceptanceConclusion',
      rules: [
        {
          required: true,
          message: '请输入质量状况',
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.qualityStatus
      },
    },
    {
      title: '验收结论',
      dataIndex: 'acceptanceConclusion',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'remark',
      rules: [
        {
          required: true,
          message: '请输入验收结论',
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.acceptanceConclusion
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.remark
      },
    },
  ]
}

//入库单
export const StorageColumns = (
  startIndex: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const [nexIndexCount, setNexIndexCount] = useState<any>()
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '200px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return (
            <Popover
              content={
                <div>
                  <div style={{ fontWeight: 'bold', lineHeight: '1.8em' }}>
                    {t.name}
                  </div>
                  <div style={{ color: '#999999', lineHeight: '1.8em' }}>
                    {t.productInfo}
                  </div>
                </div>
              }
            >
              <div
                style={{
                  textAlign: 'left',
                  lineHeight: '1.8em',
                  fontWeight: 'bold',
                }}
              >
                {t.name}
              </div>
              <div style={{ lineHeight: '1.8em', color: '#999999' }}>
                {t.productInfo}
              </div>
            </Popover>
          )
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                <div style={{ textAlign: 'left' }}>{t.name}</div>
                <p style={{ color: '#999999' }}>
                  {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                  {t.tenantSupplierName}
                </p>
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '60px',
      ellipsis: true,
      nextDataIndex: 'productDate',
      editable: true,
      rules: [
        {
          required: true,
          message: '请输入批号',
        },
        {
          pattern: new RegExp(/^\S.*\S$/),
          message: '请按规范输入',
        },
      ],
      onSave: (prev, next) => {
        // setNexIndexCount(null as any)
        setNexIndexCount('productDate')
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_, t: any) {
        return (
          <span
            onClick={() => {
              // setNexIndexCount(null as any)
              setNexIndexCount('productDate')
            }}
          >
            {t.batchNo}
          </span>
        )
      },
    },
    {
      title: '生产日期',
      align: 'center',
      dataIndex: 'productDate',
      width: '100px',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'deadline',
      rules: [
        { required: true, message: '请输入生产日期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', {
          ...prev,
          productDate: moment(next.productDate).format(DateTimeFormat),
        })
      },
      render: (productDate) => {
        return productDate &&
          productDate !== undefined &&
          productDate !== '' &&
          productDate !== 'Invalid date'
          ? moment(productDate).format(DateTimeFormatSimple)
          : undefined
      },
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '100px',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'totalQuantity',
      onSave: (prev, next) => {
        onclick('edit', {
          ...prev,
          deadline: moment(next.deadline).format(DateTimeFormat),
        })
      },
      rules: [
        { required: true, message: '请输入有效期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (deadline) => {
        return deadline &&
          deadline !== undefined &&
          deadline !== '' &&
          deadline !== 'Invalid date'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '到货数量',
      dataIndex: 'totalQuantity',
      width: '100px',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'qualifiedQuantity',
      align: 'center',
      rules: [
        {
          required: true,
          message: '请输入到货数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.totalQuantity) > Number(prev.count)) {
          notification.error({
            message: '到货数量不能大于采购数量',
          })
          return
        }
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.totalQuantity >= 0 ? t.totalQuantity : ''
      },
    },
    {
      title: '验收合格数量',
      dataIndex: 'qualifiedQuantity',
      width: '120px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'defectiveQuantity',
      rules: [
        {
          required: true,
          message: '请输入验收合格数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.qualifiedQuantity) > Number(prev.totalQuantity)) {
          notification.error({
            message: '验收合格数量不能大于到货数量',
          })
          return
        }
        if (
          Number(next.qualifiedQuantity) + Number(prev.defectiveQuantity) >
          Number(prev.totalQuantity)
        ) {
          notification.error({
            message: '验收合格数量和验收不合格数量之和不能大于到货数量',
          })
          return
        }
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.qualifiedQuantity >= 0 ? t.qualifiedQuantity : ''
      },
    },
    {
      title: '验收不合格数量',
      dataIndex: 'defectiveQuantity',
      width: '130px',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'unitPrice',
      align: 'center',
      rules: [
        {
          required: true,
          message: '请输入验收不合格数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.defectiveQuantity) > Number(prev.totalQuantity)) {
          notification.error({
            message: '验收合格数量不能大于到货数量',
          })
          return
        }
        if (
          Number(prev.qualifiedQuantity) + Number(next.defectiveQuantity) >
          Number(prev.totalQuantity)
        ) {
          notification.error({
            message: '验收合格数量和验收不合格数量之和不能大于到货数量',
          })
          return
        }
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.defectiveQuantity >= 0 ? t.defectiveQuantity : ''
      },
    },
    {
      title: '入库单价',
      dataIndex: 'unitPrice',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'retailPrice',
      rules: [
        {
          required: true,
          message: '请输入入库单价',
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '零售单价',
      dataIndex: 'retailPrice',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'realCount',
      rules: [
        {
          required: true,
          message: '请输入零售单价',
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.retailPrice ? parseFloat(t.retailPrice)?.toFixed(5) : ''
      },
    },
    {
      title: '入库数量',
      dataIndex: 'realCount',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'qualityStatus',
      rules: [
        {
          required: true,
          message: '请输入入库数量',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.realCount) > Number(prev.totalQuantity)) {
          notification.error({
            message: '入库数量不能大于到货数量',
          })
          return
        }
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.realCount
      },
    },
    {
      title: '质量状况',
      dataIndex: 'qualityStatus',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'acceptanceConclusion',
      rules: [
        {
          required: true,
          message: '请输入质量状况',
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.qualityStatus
      },
    },
    {
      title: '验收结论',
      dataIndex: 'acceptanceConclusion',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'remark',
      rules: [
        {
          required: true,
          message: '请输入验收结论',
        },
      ],
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.acceptanceConclusion
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: '100px',
      ellipsis: true,
      editable: true,
      align: 'center',
      onSave: (prev, next) => {
        onclick('edit', { ...prev, ...next })
      },
      render: function Element(_: any, t: any) {
        return t.remark
      },
    },
  ]
}

//验收业务
export const AcceptanceBusinessColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): EditableColumnType<any>[] => {
  const [nexIndexCount, setNexIndexCount] = useState<any>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '12rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '供应商',
      align: 'center',
      dataIndex: 'supplierName',
      width: '12rem',
      ellipsis: true,
      key: 'supplierName',
    },
    {
      title: '到货日期',
      dataIndex: 'arrivalDate',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'arrivalDate',
      //   sorter: (a: any, b: any) =>
      //     moment(a.createTime).unix() - moment(b.createTime).unix(),
      render: (arrivalDate) => {
        return arrivalDate
          ? moment(arrivalDate).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '到货品种',
      align: 'center',
      dataIndex: 'arrivalCategoryCount',
      width: '8rem',
      ellipsis: true,
      key: 'arrivalCategoryCount',
      render: (_, t) => {
        return t.arrivalCategoryCount >= 0 ? t.arrivalCategoryCount : 0
      },
    },
    {
      title: '合格品种',
      align: 'center',
      dataIndex: 'qualifiedCategoryCount',
      width: '8rem',
      ellipsis: true,
      key: 'qualifiedCategoryCount',
      render: (_, t) => {
        return t.qualifiedCategoryCount >= 0 ? t.qualifiedCategoryCount : 0
      },
    },
    {
      title: '合格金额',
      align: 'center',
      dataIndex: 'totalQualifiedAmount',
      width: '8rem',
      ellipsis: true,
      key: 'totalQualifiedAmount',
      render: (_, t) => {
        return t.totalQualifiedAmount >= 0 ? t.totalQualifiedAmount : ''
      },
    },
    {
      title: '审核人',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'approvedUserName',
      key: 'approvedUserName',
      render: (_, t) => {
        return t?.approvedUserName
      },
    },
    {
      title: '审核日期',
      align: 'center',
      width: '10rem',
      dataIndex: 'approvedDate',
      ellipsis: true,
      render: (_, t) => {
        return t.approvedDate
      },
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'approvedState',
      key: 'approvedState',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return getApproveStateName(t.approvedState)
      },
    },
    {
      width: '13rem',
      title: '操作',
      fixed: 'right',
      align: 'center',
      dataIndex: 'action',
      key: 'storehouseTag',
      render: function Element(_, t) {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {t.approvedState == 0 && (
              <>
                <Button
                  type='link'
                  size='small'
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    history.push({
                      pathname: '/chainPutList',
                      state: {
                        where: ['GSP业务', '验收业务'],
                        name: '单据列表',
                        backName: '库房工作站',
                        path: '/acceptanceBusiness',
                        category: Category.YSYW,
                        selectId: t.id,
                        detail: { ...t },
                      },
                    })
                  }}
                >
                  提交
                </Button>
                <Button
                  danger
                  type='link'
                  size='small'
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => onClick('delete', t)}
                >
                  删除
                </Button>
              </>
            )}
            {t.approvedState == 1 && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  history.push({
                    pathname: '/chainPutList',
                    state: {
                      where: ['GSP业务', '验收业务'],
                      name: '单据列表',
                      backName: '库房工作站',
                      path: '/acceptanceBusiness',
                      category: Category.YSYW,
                      selectId: t.id,
                      detail: { ...t },
                    },
                  })
                }}
              >
                去审核
              </Button>
            )}
            {t.approvedState == 2 && t.stockInInventoryReceiptsId < 0 && (
              <Button
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => onClick('storage', t)}
              >
                生成入库单
              </Button>
            )}
            {(t.approvedState == 1 ||
              t.approvedState == 2 ||
              t.approvedState == 3) && (
              <Button
                danger
                type='link'
                size='small'
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  onClick('revocation', t)
                }}
              >
                撤回
              </Button>
            )}
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={() => {
                history.push({
                  pathname: '/chainPutList',
                  state: {
                    where: ['GSP业务', '验收业务'],
                    name: '单据列表',
                    backName: '库房工作站',
                    path: '/acceptanceBusiness',
                    category: Category.YSYW,
                    selectId: t.id,
                    detail: { ...t },
                  },
                })
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
  return columns
}

//验收明细
export const DetailYSYWColumns = (
  storehouseId: string,
  approvedState: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const [nexIndexCount, setNexIndexCount] = useState<any>()
  return [
    {
      title: '操作',
      align: 'center',
      width: '50px',
      ellipsis: true,
      fixed: 'left',
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={approvedState == 0 ? false : true}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={approvedState == 0 ? false : true}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '40px',
      fixed: 'left',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    // 0512通用名修改 药品名称->通用名
    {
      title: '通用名',
      align: 'center',
      dataIndex: 'name',
      width: '190px',
      ellipsis: true,
      fixed: 'left',
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'batchNo',
      storehouseId: storehouseId,
      editable: approvedState == 0 ? true : false,
      inputType: 'material',
      completionType: ItemCompletionType.Material,
      onSelectMaterial: (prev, newdata) => {
        const tenantInventoryLedgerId = newdata.id
        // const unitPrice = newdata.stockPrice > 0 ? newdata.stockPrice : 0;
        const next = {
          ...newdata,
          qualityStatus: '产品完好无损',
          acceptanceConclusion: '验收合格',
          tenantInventoryLedgerId,
          productDate: '',
          deadline: '',
          id: undefined,
          remark: '',
          tenantMaterialsCatalogId: newdata.materialsCatalogId,
          materialsCatalogId: undefined,
        }
        onclick('edit', { prev, next })
      },
    },
    // 0512通用名修改 通用名->商品名
    {
      title: '商品名',
      align: 'center',
      dataIndex: 'genericName',
      width: '190px',
      ellipsis: true,
      key: 'nogenericName',
      render: (_: any, t: any) => {
        return Number(t.genericName) !== 0 ? t.genericName : ''
      },
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '470px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return <>{t.productInfo}</>
        } else {
          if (
            t.spec ||
            t.packSpec ||
            t.accountUnit ||
            t.doseCategory ||
            t.tenantSupplierName
          ) {
            return (
              <>
                {t.spec}/{t.packSpec}/{t.accountUnit}/{t.doseCategory}/
                {t.tenantSupplierName}
              </>
            )
          } else {
            return <></>
          }
        }
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '60px',
      ellipsis: true,
      // fixed: 'right',
      nextDataIndex: 'arrivalUnitPrice',
      editable: true,
      rules: [
        {
          required: true,
          message: '请输入批号',
        },
        {
          pattern: new RegExp(/^\S.*\S$/),
          message: '请按规范输入',
        },
      ],
      onSave: (prev, next) => {
        // setNexIndexCount(null as any)
        setNexIndexCount('arrivalUnitPrice')
        onclick('edit', { prev, next })
      },
      render: function Element(_, t: any) {
        return (
          <span
            onClick={() => {
              // setNexIndexCount(null as any)
              setNexIndexCount('arrivalUnitPrice')
            }}
          >
            {t.batchNo}
          </span>
        )
      },
    },
    {
      title: '采购单价',
      dataIndex: 'arrivalUnitPrice',
      width: '100px',
      // fixed: 'right',
      ellipsis: true,
      align: 'center',
      editable: true,
      nextDataIndex: 'productDate',
      rules: [
        {
          required: true,
          message: '请输入进价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_: any, t: any) {
        return t.arrivalUnitPrice && t.arrivalUnitPrice >= 0
          ? parseFloat(t.arrivalUnitPrice)?.toFixed(5)
          : ''
      },
    },
    {
      title: '生产日期',
      align: 'center',
      dataIndex: 'productDate',
      width: '100px',
      ellipsis: true,
      // fixed: 'right',
      editable: true,
      nextDataIndex: 'deadline',
      rules: [
        { required: true, message: '请输入生产日期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', {
          prev,
          next: {
            productDate: moment(next.productDate).format(DateTimeFormat),
          },
        })
      },
      render: (productDate) => {
        return productDate &&
          productDate !== undefined &&
          productDate !== '' &&
          productDate !== 'Invalid date'
          ? moment(productDate).format(DateTimeFormatSimple)
          : undefined
      },
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '100px',
      // fixed: 'right',
      ellipsis: true,
      editable: true,
      nextDataIndex: 'totalQuantity',
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', {
          prev,
          next: { deadline: moment(next.deadline).format(DateTimeFormat) },
        })
      },
      rules: [
        { required: true, message: '请输入有效期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (deadline) => {
        return deadline &&
          deadline !== undefined &&
          deadline !== '' &&
          deadline !== 'Invalid date'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '到货数量',
      dataIndex: 'totalQuantity',
      width: '100px',
      ellipsis: true,
      // fixed: 'right',
      editable: true,
      nextDataIndex: 'qualifiedQuantity',
      align: 'center',
      rules: [
        {
          required: true,
          message: '请输入到货数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (
          Number(next.totalQuantity) > Number(prev.count) &&
          prev.count >= 0
        ) {
          notification.error({
            message: '到货数量不能大于采购数量',
          })
          return
        }
        // if(prev.id) {
        //   if(Number(prev.qualifiedQuantity) + Number(prev.defectiveQuantity) > Number(next.totalQuantity)) {
        //     notification.error({
        //       message: "验收合格数量和验收不合格数量之和不能大于到货数量",
        //     })
        //     return
        //   }
        // }
        const newPrev = {
          ...prev,
          qualifiedQuantity:
            Number(next.totalQuantity || 0) -
            Number(prev.defectiveQuantity || 0),
          defectiveQuantity: Number(prev.defectiveQuantity || 0),
        }
        onclick(prev.id ? 'submit' : 'edit', { prev: newPrev, next })
      },
      render: function Element(_: any, t: any) {
        return t.totalQuantity >= 0 ? t.totalQuantity : ''
      },
    },
    {
      title: '验收合格数量',
      dataIndex: 'qualifiedQuantity',
      width: '120px',
      ellipsis: true,
      // fixed: 'right',
      editable: true,
      align: 'center',
      nextDataIndex: 'defectiveQuantity',
      rules: [
        {
          required: true,
          message: '请输入验收合格数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.qualifiedQuantity) > Number(prev.totalQuantity)) {
          notification.error({
            message: '验收合格数量不能大于到货数量',
          })
          return
        }
        // if(Number(next.qualifiedQuantity) + Number(prev.defectiveQuantity) > Number(prev.totalQuantity)) {
        //   notification.error({
        //     message: "验收合格数量和验收不合格数量之和不能大于到货数量",
        //   })
        //   return
        // }
        const newPrev = {
          ...prev,
          defectiveQuantity:
            Number(prev.totalQuantity || 0) -
            Number(next.qualifiedQuantity || 0),
        }
        onclick(prev.id ? 'submit' : 'edit', { prev: newPrev, next })
      },
      render: function Element(_: any, t: any) {
        return t.qualifiedQuantity >= 0 ? t.qualifiedQuantity : ''
      },
    },
    {
      title: '验收不合格数量',
      dataIndex: 'defectiveQuantity',
      width: '130px',
      ellipsis: true,
      // fixed: 'right',
      editable: true,
      nextDataIndex: 'qualityStatus',
      align: 'center',
      rules: [
        {
          required: true,
          message: '请输入验收不合格数量',
        },
        {
          pattern: new RegExp(/^\d+$/),
          message: '请输入正确的格式',
        },
      ],
      onSave: (prev, next) => {
        if (Number(next.defectiveQuantity) > Number(prev.totalQuantity)) {
          notification.error({
            message: '验收合格数量不能大于到货数量',
          })
          return
        }
        // if(Number(prev.qualifiedQuantity) + Number(next.defectiveQuantity) > Number(prev.totalQuantity)) {
        //   notification.error({
        //     message: "验收合格数量和验收不合格数量之和不能大于到货数量",
        //   })
        //   return
        // }
        const newPrev = {
          ...prev,
          qualifiedQuantity:
            Number(prev.totalQuantity || 0) -
            Number(next.defectiveQuantity || 0),
        }
        onclick(prev.id ? 'submit' : 'edit', { prev: newPrev, next })
      },
      render: function Element(_: any, t: any) {
        return t.defectiveQuantity >= 0 ? t.defectiveQuantity : ''
      },
    },
    {
      title: '质量状况',
      dataIndex: 'qualityStatus',
      width: '100px',
      // fixed: 'right',
      ellipsis: true,
      editable: true,
      align: 'center',
      nextDataIndex: 'acceptanceConclusion',
      rules: [
        {
          required: true,
          message: '请输入质量状况',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_: any, t: any) {
        return t.qualityStatus
      },
    },
    {
      title: '验收结论',
      dataIndex: 'acceptanceConclusion',
      width: '100px',
      ellipsis: true,
      // fixed: 'right',
      editable: true,
      align: 'center',
      nextDataIndex: 'remark',
      rules: [
        {
          required: true,
          message: '请输入验收结论',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_: any, t: any) {
        return t.acceptanceConclusion
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: '100px',
      // fixed: 'right',
      ellipsis: true,
      editable: true,
      align: 'center',
      onSave: (prev, next) => {
        onclick('submit', { prev, next })
      },
      render: function Element(_: any, t: any) {
        return t.remark
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '100px',
      fixed: 'right',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t?.tenantMaterialsCatalogId && (
            <Space>
              <Button
                ghost
                type={'primary'}
                disabled={approvedState > 0 ? true : false}
                onClick={() => {
                  onclick('save', t)
                }}
              >
                保存
              </Button>
            </Space>
          )
        )
      },
    },
  ]
}

// 复制采购单
export const CopyCGYWColumns = (
  startIndex: number,
  onClick: (action: any, t: any) => void
): TableColumnType<any>[] => {
  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '12rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '采购品种',
      align: 'center',
      dataIndex: 'submittedCategoryCount',
      width: '8rem',
      ellipsis: true,
      key: 'submittedCategoryCount',
    },
    {
      title: '采购金额',
      align: 'center',
      dataIndex: 'submittedTotalAmount',
      width: '8rem',
      ellipsis: true,
      key: 'submittedTotalAmount',
      render: (_, t) => {
        return t.submittedTotalAmount > 0 ? t.submittedTotalAmount : ''
      },
    },
    {
      title: '审核人',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'approvedUserName',
      key: 'approvedUserName',
      render: (_, t) => {
        return t?.approvedUserName
      },
    },
    {
      title: '审核日期',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      render: (_, t) => {
        return t.approvedTime
          ? moment(t.approvedTime).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return getClassificationRuleName(t.storehouseTag)
      },
    },
    {
      title: '操作',
      width: '5rem',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: function Element(_, t) {
        return (
          <>
            <Button
              type='text'
              size='small'
              style={{ color: '#027AFF', fontSize: '14px' }}
              onClick={(e) => {
                e.stopPropagation()
                onClick('detail', t)
              }}
            >
              详情
            </Button>
          </>
        )
      },
    },
  ]
  return columns
}
